module.exports = __webpack_public_path__ + "img/code_wx2.417d476e.png";